/* eslint-disable max-classes-per-file */

/**
 * Primary nav selector
 * @const {string}
 */
const PRIMARY_NAV_SELECTOR = '[data-component="primary-nav"]';

/**
 * Primary nav landmark selector
 * @const {string}
 */
const NAV_LANDMARK_SELECTOR = '.primary-nav__landmark';

/**
 * Menu expander button control
 * @const {string}
 */
export const MENU_EXPANDER_SELECTOR = '.primary-nav-item--has-children';

/**
 * FB Check
 * @const {string}
 */
export const FB_EL_CHECK = '.funnelback-search';

/**
 * Create a new PrimaryNav
 * @param {HTMLElement} PrimaryNav - The HTML element of the primary nav
 * @class
 */
class PrimaryNavImpl {
    constructor(primaryNav) {
        this.primaryNav = primaryNav;

        const menuExpanders = primaryNav.querySelectorAll(
            MENU_EXPANDER_SELECTOR
        );

        const primaryNavLandmark = primaryNav.querySelector(
            NAV_LANDMARK_SELECTOR
        );

        // How many milliseconds of transition-delay the menu has before it appears (set in the SCSS)
        const msMenuDelay = 300;

        menuExpanders.forEach((navItem) => {
            // for each nav item, assign the menu offset property for usage by mega menu
            const childMenu = navItem.querySelector(
                '.primary-nav-item__child-menu'
            );

            navItem.addEventListener('mouseover', () => {
                // menu offset should be that of the primary nav
                if (childMenu) childMenu.setAttribute('aria-expanded', true);
                this._setMenuOffset(primaryNavLandmark, navItem);
                setTimeout(() => {
                    if (
                        childMenu ||
                        navItem.srcElement === document.querySelector(':hover')
                    ) {
                        primaryNavLandmark.classList.add('active');
                    } else primaryNavLandmark.classList.remove('active');
                }, msMenuDelay);
            });

            // update aria label on mouseout
            navItem.addEventListener('mouseout', () => {
                if (childMenu) childMenu.setAttribute('aria-expanded', false);
                setTimeout(() => {
                    if (
                        childMenu ||
                        navItem.srcElement !== document.querySelector(':hover')
                    ) {
                        primaryNavLandmark.classList.remove('active');
                    } else primaryNavLandmark.classList.remove('active');
                }, msMenuDelay);
            });

            navItem.addEventListener('focusin', () => {
                // menu offset should be that of the primary nav
                if (childMenu) childMenu.setAttribute('aria-expanded', true);
                this._setMenuOffset(primaryNavLandmark, navItem);
            });

            // update aria label on mouseout
            navItem.addEventListener('focusout', () => {
                if (childMenu) childMenu.setAttribute('aria-expanded', false);
            });
        });
    }

    _setMenuOffset(primaryNavLandmark, primaryNavItem) {
        const navItem = primaryNavItem;
        navItem.style.setProperty(
            '--menuOffsetNeeded',
            `${primaryNavLandmark.offsetLeft}px`
        );
    }
}

/**
 * Singleton wrapper for Primary Nav to allow control from other areas of the template.
 * @class
 */
export default class PrimaryNav {
    static getInstance() {
        const primaryNav = document.querySelector(PRIMARY_NAV_SELECTOR);
        const fbActive = !!document.querySelector(FB_EL_CHECK);

        // primaryNav doesnt exist, return null
        if (!primaryNav) {
            return null;
        }

        // Doesnt exist yet, create new menu object
        if (!primaryNav._primaryNav) {
            // Store the actual class against the DOM, as if this is destroyed for any reason it will need to be re-instantiated
            primaryNav._primaryNav = new PrimaryNavImpl(primaryNav);
        } else if (fbActive) {
            // Is Funnelback
            primaryNav._primaryNav = new PrimaryNavImpl(primaryNav);
        }

        // Return existing primaryNav object
        return primaryNav._primaryNav;
    }
}

// Export for external access and run intial pass
PrimaryNav.getInstance();
